'use client';
import Sidebar from '@/components/Sidebar';
import HoiDap from './components/HoiDap';

export default function HoiDapPage(props) {
  const { rightBanners, linkPages, websiteCode } = props;

  return (
    <div className="flex flex-col lg:flex-row gap-6">
      <main className="lg:w-3/4">
        <HoiDap {...props} />
      </main>
      <div className="w-full md:w-1/4 ">
        <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
      </div>
    </div>
  );
}
